<template>
    <el-row class="alltext" :style='{height:all_height}'>
      <div v-if="liad_show">
        <load></load>
      </div>
      <b>组织架构</b>
     <div class="firstdiv">
       <el-button type="primary" @click="section_up('add','','')" >新增部门</el-button>
       <el-button type="primary" @click="companyee_up('add','','')">新增员工</el-button>
       <el-button type="primary" @click="nav_status.companyee_insert = true">生成邀请码</el-button>
     </div>
     <div class="content_alltext">
       <div class="content_left">
         <span style="font-size: 20px; margin-bottom:20px ;">部门管理</span>
           <el-tree ref="tree" :data="section_list" node-key="section_list.num"  draggable>
        <div class="tree-node " slot-scope="{data}">
          <div class="tree-node ">
            <span  class="node-tit">{{data.name}}</span>
            <span style="position:absolute; right: 0;">
              <i class="el-icon-edit" @click="section_up('edit',data.num,'')" style="cursor: pointer;"></i>
              <el-dropdown >
                <span class="el-dropdown-link">
                  <i class="el-icon-plus"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="() => section_up('add','',data.num)">添加部门</el-dropdown-item>
                  <el-dropdown-item @click.native="() => companyee_up('add','',data.num)">添加人员</el-dropdown-item>
                </el-dropdown-menu>
             </el-dropdown>
             <i class="el-icon-close" @click="section_del(data.num)"></i>
            </span>
          </div>
        </div>
      </el-tree>
       </div>
       <!--所属部门弹框（部门）-->
       <el-dialog title="所属部门 ":visible.sync="nav_status.section_choice" :before-close="handleClose">
         <div style="display: flex;">
           <div class="ercitankuang_left">
             <el-input
             style="margin-top: 1rem; margin-left: 1rem; margin-bottom: 0.3rem; width: 90%;"
               placeholder="部门名称"
               v-model="filterText">
             </el-input>
             <el-tree   @node-click="section_fid"
                :data="section_list"
                 ref="tree"
                 node-key="id"
                :filter-node-method="filterNode"
                :props="defaultProps"
                >
            </el-tree>
           </div>
           <div class="ercitankuang_content">
             <i class="el-icon-right"></i>
           </div>
             <div class="ercitankuang_right">
              <div v-html="section_choiced.html" @click="del_section_edit_fid_click($event)"></div>
             </div>
         </div>

          <div slot="footer" class="dialog-footer">
            <el-button @click="section_choice_remove()">取 消</el-button>
            <el-button type="primary" @click="nav_status.section_choice = false">确 定</el-button>
          </div>
       </el-dialog>

       <!--新增部门-->
       <el-dialog :title="nav_status.title ":visible.sync="nav_status.section">
         <el-form :model="section_edit">
           <el-form-item label="部门名称" :label-width="formLabelWidth">
             <el-input v-model="section_edit.name" autocomplete="off" style="width: 80%;"  placeholder="部门名称"></el-input>
           </el-form-item>
           <el-form-item label="所属部门" :label-width="formLabelWidth">
             <div v-html="section_choiced.html" @click="del_section_edit_fid_click($event)"></div>
            <el-button plain @click="section_choice()">请选择</el-button>
           </el-form-item>
           <el-form-item label="权重" :label-width="formLabelWidth">
             <el-input type="number" v-model="section_edit.order" autocomplete="off" style="width: 80%;"></el-input>
           </el-form-item>
         </el-form>
         <div slot="footer" class="dialog-footer">
           <el-button @click="nav_status.section = false">取 消</el-button>
           <el-button type="primary" @click="section_save()">确 定</el-button>
         </div>
       </el-dialog>

       <el-dialog title="状态变更":visible.sync="nav_status.companyee_status">
         <el-form :model="companyee_status_edit">
            <el-form-item label="状态" :label-width="formLabelWidth" >
              <el-select v-model="companyee_status_edit.status" style="width: 80%;">
                <el-option label="启用" value="1"></el-option>
                <el-option label="禁用" value="2"></el-option>
                <el-option label="离职" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" :label-width="formLabelWidth" >
              <el-input
                type="textarea"
                autosize
                placeholder="备注"
                v-model="companyee_status_edit.content">
              </el-input>
            </el-form-item>
         </el-form>
         <div slot="footer" class="dialog-footer">
           <el-button @click="nav_status.companyee_status = false">取 消</el-button>
           <el-button type="primary" @click="companyee_status_save()">确 定</el-button>
         </div>
       </el-dialog>

       <!--新增人员-->
       <el-dialog :title="nav_status.title"   :visible.sync="nav_status.companyee">
         <el-form :model="companyee_edit">
           <el-form-item label="真实姓名" :label-width="formLabelWidth">
             <el-input v-model="companyee_edit.rale_name" autocomplete="off" style="width: 80%;"  placeholder="真实姓名"></el-input>
           </el-form-item>
           <el-form-item label="账号" :label-width="formLabelWidth">
             <el-input v-model="companyee_edit.name" autocomplete="off" style="width: 80%;" placeholder="建议使用邮箱或手机号"></el-input>
           </el-form-item>
           <el-form-item label="密码" :label-width="formLabelWidth">
             <el-input  show-password v-model="companyee_edit.pwd" type="password" autocomplete="off" style="width: 80%;" placeholder="未填密码将使用默认密码(手机号)"></el-input>
           </el-form-item>
           <el-form-item label="手机号" :label-width="formLabelWidth" >
             <el-input v-model="companyee_edit.phone" autocomplete="off" style="width: 80%;" placeholder="手机号"></el-input>
           </el-form-item>
           <el-form-item label="所属部门" :label-width="formLabelWidth">
             <div v-html="section_choiced.html" @click="del_section_edit_fid_click($event)"></div>
              <el-button plain @click="section_choice()">请选择</el-button>
           </el-form-item>
           <el-form-item label="角色" :label-width="formLabelWidth">
             <el-select v-model="companyee_edit.role_type" style="width: 80%;">
               <el-option label="员工" value="0"></el-option>
               <el-option label="部门管理员" value="1"></el-option>
               <el-option label="企业管理员" value="2"></el-option>
             </el-select>
           </el-form-item>
           <el-form-item label="账号到期时间" :label-width="formLabelWidth" >
             <el-date-picker
                   v-model="companyee_edit.time"
                   type="datetime"
                   value-format="yyyy-MM-dd HH:mm:ss"
                   placeholder="截止时间">
                 </el-date-picker>
           </el-form-item>
           <el-form-item label="入职任务自动派发" :label-width="formLabelWidth" >
             <el-select v-model="companyee_edit.train_status" style="width: 80%;">
               <el-option label="开启" value="1" selected></el-option>
               <el-option label="关闭" value="0"></el-option>
             </el-select>
           </el-form-item>
         </el-form>
         <div slot="footer" class="dialog-footer">
           <el-button @click="nav_status.companyee = false">取 消</el-button>
           <el-button type="primary" @click="companyee_save()">确 定</el-button>
         </div>
       </el-dialog>
       <el-dialog
         title="添加/修改员工编号"
         :visible.sync="edituser_num.dialogVisible"
         width="30%"
         >
         <el-input v-model="edituser_num.input" placeholder="请输入内容"></el-input>
         <span slot="footer" class="dialog-footer">
           <el-button @click="edituser_num.dialogVisible = false">取 消</el-button>
           <el-button type="primary" @click="edituser_ok">确 定</el-button>
         </span>
       </el-dialog>

       <div class="content_right"  ref="content_right" :style="{height: content_right_height}">
          <span style="font-size: 20px;">人员管理</span>
          <span style="font-size: 0.625rem;">（【变更信息】中带【*】说明人员姓名经历过变更）</span>
          <div style="margin: 1.25rem 0;">
            <el-input placeholder="真实姓名、手机号"  v-model="search_value" @keyup.enter.native="search_click()"  prefix-icon="el-icon-search"   style="width: 20%; float:right; " ></el-input>
            <el-select v-model="employee_status_value" placeholder="员工状态筛选">
                <el-option
                  v-for="item in employee_status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-button type="primary" round  @click="employee_status_click()">筛选</el-button>
          </div>
          <div >
             <el-table
                 :data="companyee_list.list"
                 stripe
                 style="width: 100%">
                 <el-table-column
                   prop="num"
                   label="员工编号(双击可修改)"
                   sortable
                  >
                  <template slot-scope="scope">
                    <div @dblclick="changeEnddate(scope.$index, scope.row)"  >
                    <span v-if="scope.row.number=='0'">待录入</span>
                    <span v-else>{{scope.row.number}}</span>
                    </div>
                  </template>
                 </el-table-column>
                 <el-table-column
                   prop="name"
                   label="真实姓名"
                   sortable
                  >
                 </el-table-column>
                 <el-table-column
                   prop="phone"
                   label="手机号"
                  >
                 </el-table-column>
                 <el-table-column
                   prop="section"
                   label="部门">
                 </el-table-column>
                 <el-table-column
                   label="变更信息">
                   <template slot-scope="scope">
                     <el-button round  size="small" v-if="scope.row.name_change_status==0"  @click ="companyee_change(scope)" >查看</el-button>
                     <el-button round  size="small" v-else  @click ="companyee_change(scope)" >查看【*】</el-button>
                   </template>
                 </el-table-column>
                 <el-table-column
                   prop="time"
                   label="创建时间">
                 </el-table-column>
                 <el-table-column label="状态">
                   <template slot-scope="scope">
                     <span v-if="companyee_list.list[scope.$index].status==1">启用中</span>
                     <span v-if="companyee_list.list[scope.$index].status==2">已禁用</span>
                     <span v-if="companyee_list.list[scope.$index].status==3">已离职</span>
                   </template>
                 </el-table-column>
                 <el-table-column
                   label="操作">
                   <template slot-scope="scope">
                    <i class="el-icon-edit"  style="cursor: pointer;" @click="companyee_up('edit',companyee_list.list[scope.$index].num,'')"></i>
                    <i class="el-icon-close" style="cursor: pointer;" @click="companyee_up('status',companyee_list.list[scope.$index].num,'')"></i>
                    </template>
                 </el-table-column>
               </el-table>
          </div>
          <div class="fenye">
           <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
             :current-page="companyee_list.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="companyee_list.pageSize"
             layout="total, sizes, prev, pager, next, jumper" :total="companyee_list.total">
           </el-pagination>
          </div>
       </div>
     </div>
     <el-dialog title=查看 :visible.sync="nav_status.companyee_change">
       <el-table :data="companyee_change_list.list.data" stripe style="width: 100%">
        <el-table-column prop="a_id" label="变更人" sortable></el-table-column>
        <el-table-column prop="info" label="变更内容" sortable></el-table-column>
        <el-table-column prop="time" label="变更时间"></el-table-column>
       </el-table>
         <el-pagination
         style="text-align: center;margin-top: 0.625rem;"
               @size-change="nav_status_handleSizeChange"
               @current-change="nav_status_handleCurrentChange"
               :current-page.sync="companyee_change_list.current_page"
               :page-size="10"
               layout="total, prev, pager, next"
               :total="companyee_change_list.list.total">
             </el-pagination>
       <div slot="footer" class="dialog-footer">
           <el-button @click="nav_status.companyee_change = false">取 消</el-button>
         </div>
     </el-dialog>
     <el-dialog title='请选择邀请码的有效期' :visible.sync="nav_status.companyee_insert" style="text-align: center;">
                <el-date-picker
                 :picker-options="time_option"
                 v-model="nav_status.time"
                 format="yyyy-MM-dd"
                 value-format="yyyy-MM-dd"
                 type="daterange"
                 unlink-panels
                 style="margin-top: 8%;"
                 range-separator="至"
                 start-placeholder="开始日期"
                 end-placeholder="结束日期">
                </el-date-picker>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="nav_status_determine()">确 定</el-button>
                <el-button @click="nav_status.companyee_insert = false">取 消</el-button>
              </div>
          </el-dialog>

          <el-dialog title='邀请注册二维码' :visible.sync="nav_status.companyee_insert_img_status" style="text-align: center;">
             <img :src="companyee_insert_img" alt="">
           </el-dialog>
    </el-row>
</template>
<script>
  import load from '../../components/load.vue';
  export default {
     watch: {
          filterText(val) {
            this.$refs.tree.filter(val);
          }
        },

    name: 'App',
    data() {
      return {
        content_right_height:'',
        all_height:'',
         employee_status: [
          {
              value: '0',
              label: '全部'
          },
          {
              value: '1',
              label: '启用'
          },
          {
              value: '2',
              label: '禁用'
          },
          {
              value: '3',
              label: '离职'
          },
        ],
         employee_status_value: '',
        time_option: {
          disabledDate(time) {
              return time.getTime() < Date.now() -8.64e7;
          },
        },
        edituser_num:{
          dialogVisible:false,
          input:'',
          item:{}
        },
        filterText:'',
        liad_show:false,
        nav_status:{
          time:"",
          section:false,
          companyee:false,
          companyee_status:false,
          companyee_insert_img_status:false,
          section_choice:false,
          title:'',
          companyee_change:false,
          companyee_insert:false,
        },
        companyee_insert_img:'',

        section_list:[],
        companyee_list:{},
        companyee_change_list:{
          current_page:'1',
          list:[],
          list_show:{}

        },
        section_edit:{
          type:'',
          fid:{},
        },

        companyee_edit:{
          type:'',
          fid:{},
        },

        section_choiced:{
          type:'',
          html:''
        },

        companyee_status_edit:{},

        defaultProps: {
         children: 'children',
         label: 'name'
       },
        search_value:'',//搜索框的值
        formLabelWidth: '20%',
        tree_default:[],
     }
    },
    components: {
       load:load
    },
    mounted: function() {
      this.get_section()
      let topHeight = this.$refs.content_right.offsetHeight // 头部高度
      this.all_height=document.documentElement.clientHeight+'px'
      this.content_right_height=document.documentElement.clientHeight-topHeight+'px'
    },
    methods: {
       nav_status_handleSizeChange(val) {
              // console.log(`每页 ${val} 条`);
        },
       nav_status_handleCurrentChange(val) {
         this.companyee_change_list.current_page=val
          this.companyee_change(this.companyee_change_list.list_show)
        },
      employee_status_click(){
        let _this=this
        _this.axios.get("/v2/c_companyee/get_list_status",{params:{'page':_this.companyee_list.currentPage,'limit':_this.companyee_list.per_page,'status':_this.employee_status_value}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.companyee_list=res.data.data;
                _this.liad_show=false
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      nav_status_determine(){
        let _this=this
        if(!_this.nav_status.time[0] || !_this.nav_status.time[0] || _this.nav_status.time[0]=='' || _this.nav_status.time[1]==''){
          _this.$message.error("请选择完整时间段");return
        }
        _this.companyee_insert(_this.nav_status.time)
      },
      companyee_insert(time){
        let _this=this
        _this.axios.post('/v2/c_section/companyee_insert',{time:time}).then(function(res) {
          if (res.status == "200") {
            if(res.data.code=='1'){
              _this.nav_status.time=''
              _this.nav_status.companyee_insert=false
              _this.companyee_insert_img=res.data.data
              _this.nav_status.companyee_insert_img_status=true
            }else{
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      changeEnddate(key,item){
        let _this=this
        _this.edituser_num.key=key
        _this.edituser_num.dialogVisible=true
        _this.edituser_num.input=item.number
      },
      edituser_ok(){
        let _this=this
        var data={
          'num':_this.companyee_list.list[_this.edituser_num.key].num,
          'number':_this.edituser_num.input
        }
        _this.axios.post("/v2/c_companyee/save_number",{data:data}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.companyee_list.list[_this.edituser_num.key].number=data.number
              _this.edituser_num.dialogVisible=false
              _this.$message.success(res.data.msg);
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
        filterNode(value, data) {
              if (!value) return true;
              return data.name.indexOf(value) !== -1;
            },
      search_click(){
        this.get_companyee('1','10')
      },
      get_companyee(page,num){
        let _this = this;
        _this.axios.get("/v2/c_companyee/get_list",{params:{'page':page,'limit':num,'keyword':_this.search_value,'type':'section','change':'change'}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.companyee_list=res.data.data;
                _this.liad_show=false
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      get_section(){
        let _this = this;
        _this.liad_show=true
          _this.axios
        .get("/v2/c_section/get_list"
        )
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.section_list=res.data.data;
                _this.get_companyee('1','10')
            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      get_section_info(type,num){
        let _this = this;
        _this.axios.get("/v2/c_section/get_info",{params:{'num':num}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              if(type=='add'){
                _this.save_section_edit_fid('section',res.data.data)
              }else{
                _this.$set(_this.section_edit,'name',res.data.data.name)
                _this.$set(_this.section_edit,'order',res.data.data.order)
                if(res.data.data.fid!='0'){
                    _this.get_section_info('add',res.data.data.fid)
                }
                _this.nav_status.section=false
                _this.nav_status.section=true
              }
            } else {
              _this.$message.error(res.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      handleSizeChange(val) {
        this.companyee_list.currentPage = 1;
        this.companyee_list.per_page = val;
        if(this.employee_status_value==''){
            this.get_companyee('1',val)
        }else{
            this.employee_status_click('1',val)
        }
      },
      handleCurrentChange(val) {
        let _this=this
        _this.companyee_list.currentPage = val
        if(_this.employee_status_value==''){
          _this.get_companyee(val,_this.companyee_list.per_page)
        }else{
          _this.employee_status_click(val,_this.companyee_list.per_page)
        }

      },

      section_up(type,num,fid){
        let _this=this
        _this.section_choiced.type='section'
        _this.section_choiced.html=''
        _this.section_edit={}
        _this.section_edit.fid={}
        _this.section_edit.type=type
        if(num!=''){
          _this.section_edit.num=num
          _this.get_section_info('edit',num);
        }
        if(fid!=''){
          _this.get_section_info('add',fid)
        }
        _this.nav_status.section=true
      },

      section_choice(){
        this.nav_status.section_choice=true
      },

      section_fid(data){
        let _this=this
        if(_this.section_choiced.type=='section'){
          _this.section_choiced.html=''
          _this.section_edit.fid={}
          _this.save_section_edit_fid('section',data)
        }else{
          if(_this.section_edit.fid.hasOwnProperty(data.num)){
            _this.del_section_edit_fid(data.num);
          }else{
            _this.save_section_edit_fid('section',data)
          }
        }
      },

      change_section_choiced(){
        let _this=this
        _this.section_choiced.html=''
        for(let key  in _this.section_edit.fid){
          _this.section_choiced.html+="<span>"+_this.section_edit.fid[key]+"<span class='"+key+"' style='padding:0 20px;cursor:pointer'>X</span></span>"
        }
      },

      del_section_edit_fid_click:function(event){
        let _this=this
        if(event.target.className){
          _this.del_section_edit_fid(event.target.className)
        }else{
          return false;
        }
      },

      save_section_edit_fid(type,data){
        let _this=this
        if(type=='section'){
            _this.section_edit.fid[data.num]=data.name
        }else{
          for(var i=0;i<data.length;i++){
            _this.section_edit.fid[data[i].num]=data[i].name
          }
        }

        _this.change_section_choiced()
      },

      del_section_edit_fid(num){
        let _this=this
        delete _this.section_edit.fid[num];
        _this.change_section_choiced()
      },

      section_choice_remove(done){
        let _this=this
        _this.$confirm('确认取消所选部门？').then(_ => {
          _this.section_choiced=''
          _this.section_edit.fid={}
          done();
        })
        .catch(_ => {});
      },

      handleClose(done) {
        let _this=this
        _this.$confirm('确认所选部门？').then(_ => {
          done();
        })
        .catch(_ => {});
      },

      get_section_up_data(){
        let _this=this
        var data={}
        data.type=_this.section_edit.type
        data.name=_this.section_edit.name
        data.order=_this.section_edit.order
        if(_this.section_edit.hasOwnProperty('num')){
          data.num=_this.section_edit.num
        }
        data.fid=_this.section_edit.fid
        var temp=Array()
        for(var key in data.fid){
          temp.push(key)
        }
        data.fid=temp
        return data
      },

      section_save(){
        let _this=this
        var data=_this.get_section_up_data()
        _this.axios.post("/v2/c_section/section_up",{data:data}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.get_section();
                _this.nav_status.section=false
                _this.$message.success(res.data.msg);
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      section_del(num){
        let _this=this
        var data={
          'type':'del',
          'num':num
        }
        _this.axios.post("/v2/c_section/section_up",{data:data}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.get_section();
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      companyee_up(type,num,section){
        let _this=this
        _this.section_choiced.type='companyee'
        _this.section_choiced.html=''
        _this.section_edit.fid={}
        _this.companyee_edit={}
        _this.companyee_edit.type=type
        if(type!='status'){
          if(num!=''){
            _this.companyee_edit.num=num
            _this.get_companyee_info(num);
          }
          if(section!=''){
            _this.get_section_info('add',section)
          }
          _this.nav_status.companyee=true
        }else{
          _this.companyee_status_edit={}
          _this.companyee_status_edit.num=num
          _this.companyee_status_edit.type=type
          _this.nav_status.companyee_status=true
        }
      },

      get_companyee_info(num){
        let _this = this;
        _this.axios.get("/v2/c_companyee/get_companyee_info",{params:{'num':num}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.companyee_edit=res.data.data
              _this.companyee_edit.type='edit'
              if(res.data.data.section!='0'){
                _this.save_section_edit_fid('companyee',res.data.data.section)
              }
              delete _this.companyee_edit['section'];
              _this.nav_status.companyee=false
              _this.nav_status.companyee=true
            } else {
              _this.$message.error(res.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      companyee_save(){
        let _this=this
        var data=_this.get_companyee_section()
        _this.axios.post("/v2/c_companyee/companyee_up",{data:data}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.$message.success(res.data.msg)
                _this.nav_status.companyee=false
                _this.get_companyee('1','10');
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      get_companyee_section(){
        let _this=this
        var data=_this.companyee_edit
        var temp=Array()
        for(var key in _this.section_edit.fid){
          temp.push(key)
        }
        data.section=temp
        return data
      },

      companyee_status_save(){
        let _this=this
        _this.axios.post("/v2/c_companyee/companyee_up",{data:_this.companyee_status_edit}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.$message.success(res.data.msg)
                _this.nav_status.companyee_status=false
                _this.get_companyee('1','10');
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      companyee_change(data){
        let _this=this
        _this.liad_show=true
        _this.axios.get("/v2/c_companyee/get_companyee_status_change",{params:{'companyee':data.row.num,page:_this.companyee_change_list.current_page}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.companyee_change_list.list=res.data.data
                _this.companyee_change_list.list_show=data
                _this.companyee_change_list.current_page=res.data.data.current_page
                _this.nav_status.companyee_change=true;
                _this.liad_show=false
            } else {
              _this.$message.error(res.data.msg);
              _this.liad_show=false
            }
          } else {
            _this.$message.error("服务器内部错误");
            _this.liad_show=false
          }
        });
      }

    }
  }
</script>
<style scoped>
 .ercitankuang_content{
   flex: 0.2;
    text-align:center;
    height: 200px;
  }
  .ercitankuang_left{
   border:1px solid 	#9D9D9D;
   height: 200px;
   flex: 1;
   overflow:scroll;
  }
  .ercitankuang_right{
    border:1px solid 	#9D9D9D;
    height: 200px;
    flex: 1;
    overflow:scroll;
  }
  .left_item{
     width: 100%;
     position:relative;
   }
  .fenye{
    margin-top: 10px;
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content_right_first{
    margin: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

b{
  font-size: 25px;
}
.alltext{
  padding: 20px;
  background-color: white;
  height: 100%;
}
.firstdiv{
  margin-top: 10px;
  border:1px solid 	#9D9D9D;
  width: 95%;
  height: 70px;
  display: flex;
  align-items: center;
  padding-left: 20px;
}
.content_alltext{
  width: 96%;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.content_left{
   border:1px solid 	#9D9D9D;
   width: 30%;
   padding: 10px;
   max-height:400px;
   margin-right: 10px;
   overflow: auto;

}
.content_right{
  border:1px solid 	#9D9D9D;
  width: 69%;
  padding: 20px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/view/company/section.vue